export const release = {
    labels: {
        release: "Lançamento",
        releases: "Lançamentos",
        releases_types: "Tipos de Lançamento",
        code: "Código",
        description: "Descrição",
        edit_release: "Editar Lançamento",
        name: "Nome",
        slug: "Slug",
    },
    placeholders: {
        code: "Exe: BR",
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_release: "Adicionar Lançamento",
            edit_release: "Editar Lançamento",
            del_release: "Excluir Lançamento",
        },
        messages: {
            del_release: "Você deseja mesmo excluir o lançamento <strong>{name}</strong>?<br/>Todos os relacionamentos deste lançamento serão excluídos.",
        },
    },
    texts: {
    },
};
